const api = require("./api");

const getImages = async () => {
  return await api.getAllResource("images");
};

const getAdminImages = async () => {
  return await api.getAllResource("admin/images");
};

const updateImage = async (id, body) => {
  return await api.updateResource("images", id, body);
};

const deleteImage = async (id) => {
  return await api.deleteResource("images", id);
};

const buildImgProperties = (image) => {
  const src = image.urls.filter((item) => item.type === "default")[0].url;
  const baseForsrcSet = image.urls.filter((item) => !isNaN(item.type));

  let srcSet = [];
  for (let item of baseForsrcSet) {
    srcSet.push(`${item.url} ${item.type}w`);
  }

  return { src, srcSet: srcSet.join(", ") };
};

const buildImageResultProperties = (image) => {
    return ({key: image.id, collections: image.collections, ...buildImgProperties(image)})
}

const buildImageSet = (apiImages) => {
    return apiImages.map(item => (buildImageResultProperties(item)))
}

module.exports = {
  getImages,
  getAdminImages,
  updateImage,
  deleteImage,
  buildImageSet,
  buildImgProperties,
  buildImageResultProperties
};
